module.exports = __webpack_public_path__ + "static/Terms-5010999608a4e59fa3a1140457349bda.pdf";